//
// locales/glitch/ms.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/flavours/glitch/locales/ms';
import localeData from 'react-intl/locale-data/ms.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
